/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/ScheduleViaSmsOrEmail/Content/TemplateType/Option"
  
}) {
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let scheduleViaTemplateTypeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_via',
path: 'template_type',
})
let optionIdValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let aggregateData = fromAggregate.equals(scheduleViaTemplateTypeValueData, optionIdValueData)
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="option.text"
 text={optionTextValueData}
 width="50%"
 onClick={onClick}
 data="schedule_via.template_type"
 data="option.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}